import React, { Component, Fragment } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";

class PageNotFound extends Component {
  render() {
    return (
      <Fragment>
        <div className="container-fluid footer-clearance _404-bg">
          <div className="row">
            <div className="col-12 text-center">
              <h1>404</h1>
              <h3>Page not found</h3>
            </div>
          </div>
        </div>
      </Fragment>
    );
  }
}

const mapStateToProps = (state, routeParams) => {
  const { loadingTypes } = state.loading;

  return {
    isLoading: loadingTypes.length > 0,
  };
};

export default withRouter(connect(mapStateToProps)(PageNotFound));
